/**
 * Mobile navigation actions
 *
 * @since   1.0.0
 * @package lighting-pros
 */

(function($) {
	$(document).ready(function() {

		// things
		var $window = $(window);
		var $header = $('header[role=banner]');
		var $nav = $('nav', $header);
		var $navToggle = $('#menu-toggle', $header);
		var $adminBar = $('#wpadminbar');
		var $navOverlay = $('.nav-overlay', $header);
		var $primaryMenuParentMenuItems = $('#primary-menu .menu-item-has-children');
		var $subMenuToggles;

		// heights
		var windowHeight;
		var headerHeight;
		var navHeight;
		var adminBarHeight;

		// init stuff
		maybeScrollY();
		addSubmenuToggles();

		// bind events
		$window.resize(maybeScrollY);
		$navToggle.click(toggleMenu);
		$subMenuToggles.click(toggleSubmenu);
		$navOverlay.click(toggleMenu);


		/**
		 * Toggler: toggle class and position menu
		 *
		 * @since 1.0.0
		 */
		function toggleMenu() {
			$nav.toggleClass('toggled');
			$navToggle.toggleClass('toggled');
			$navOverlay.fadeToggle();
		}


		/**
		 * Get the header, nav, and admin bar heights
		 *
		 * @since 1.0.0
		 */
		function getHeights() {
			windowHeight = $window.height();
			headerHeight = $header.outerHeight();
			navHeight = $nav.outerHeight();
			adminBarHeight = $adminBar.outerHeight();
		}


		/**
		 * Maybe scroll overflow-y
		 *
		 * If the height of the menu goes beyond what's visible on the screen,
		 * allow some scrolling
		 *
		 * @since 1.0.0
		 */
		function maybeScrollY() {

			// reset scroll-y so height is calculated correctly
			$nav.removeClass('scroll-y');

			// get our heights
			getHeights();

			// calculate usable height
			var usableHeight = windowHeight - headerHeight - adminBarHeight;

			// compare
			if (usableHeight < navHeight) {
				$nav.addClass('scroll-y');
			}
		}


		/**
		 * Add mobile submenu dropdown toggles, then bind them to toggles var
		 *
		 * @since 1.0.0
		 */
		function addSubmenuToggles() {

			$primaryMenuParentMenuItems.append(
				'<button class="toggle-sub"><span class="screen-reader-text">Menu</span><i class="fas fa-chevron-down"></i></button>'
			);

			$subMenuToggles = $('.toggle-sub', $primaryMenuParentMenuItems);
		}


		/**
		 * Toggle mobile submenu
		 *
		 * @since 1.0.0
		 */
		function toggleSubmenu() {

			var $li = $(this).parent();
			$li.toggleClass('sub-toggled');

			// double-check the scroll-y
			$('> .sub-menu', $li).slideToggle(300, maybeScrollY);
		}

		/**
		 * if not IE do primary nav follow along links
		 *
		 * @since 1.0.0
		 */
		var followAlongLinks = function() {
			var $primaryMenu = document.querySelector('#primary-menu');
			var $triggers = document.querySelectorAll('#primary-menu li');
			var $submenuLis = document.querySelectorAll('#primary-menu .sub-menu li');
			var highlight = document.createElement('span');
			highlight.classList.add('link-highlight');
			$primaryMenu.appendChild(highlight);

			function highlightLink(e) {
				e.preventDefault();
				var menuCoords = $primaryMenu.getBoundingClientRect();
				var linkCoords = this.getBoundingClientRect();
				var coords = {
					width: linkCoords.width,
					height: linkCoords.height,
					top: linkCoords.top - menuCoords.top,
					left: linkCoords.left - menuCoords.left,
				};
				TweenMax.to(highlight, 0.3, {
					autoAlpha: 1,
					width: coords.width,
					left: coords.left,
					scaleX: 0.9,
					ease: Back.easeOut.config(1)
				});
			}

			if (window.innerWidth > 1300) {

				$triggers.forEach(function(link) {
					link.addEventListener('mouseenter', highlightLink);
				});

				$primaryMenu.addEventListener('mouseleave', function() {
					TweenMax.to(highlight, 0.3, {
						autoAlpha: 0,
						width: 0,
						ease: Circ.easeOut
					});
				});

				$primaryMenu.addEventListener('mouseenter', function() {
					TweenMax.to(highlight, 0.3, {
						autoAlpha: 1,
						ease: Circ.easeOut
					});
				});

				$submenuLis.forEach(function(link) {

					link.addEventListener('mouseenter', function() {
						TweenMax.to(highlight, 0.3, {
							autoAlpha: 0,
							width: 0,
							ease: Circ.easeOut
						});
					});
					link.addEventListener('mouseleave', function() {
						TweenMax.to(highlight, 0.3, {
							autoAlpha: 1,
							ease: Circ.easeOut
						});
					});

				});

			}

		};

		if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
			return;
		} else {
			followAlongLinks();
		}

	}); // document.ready
})(jQuery);
